export class AuthenticationWorkflow {
    credentialsStore;
    constructor(credentialsStore) {
        this.credentialsStore = credentialsStore;
    }
    performLogin(context) {
        const data = {
            username: context.username,
            token: "123456",
        };
        this.credentialsStore.setCredentials(data, context.remember);
        return data;
    }
    performLogout() {
        this.credentialsStore.setCredentials();
        return true;
    }
}
